import { SignalIcon } from '@heroicons/react/24/outline'
import { isEmpty, map } from 'lodash'
import { FormattedMessage } from 'react-intl'

import messages from './messages'

const PopulateAudiences = (audiences: any | undefined, defaultAudienceAll = false) => {
  if (isEmpty(audiences) && defaultAudienceAll) {
    return (
      <div className="row text-zinc-400" key={'default-audience'}>
        <SignalIcon className="h-5 w-5" />
        <FormattedMessage {...messages.allUsers} />
      </div>
    )
  }
  if (isEmpty(audiences)) return

  return map(audiences, populateAudience)
}
PopulateAudiences.displayName = 'PopulateAudiences'
export default PopulateAudiences

const populateAudience = (audience: { filters: any }) => {
  if (isEmpty(audience) || isEmpty(audience.filters)) return
  const response = []
  for (let i = 0; i < audience.filters.length; i++) {
    if (audience.filters.length > 1 && i > 0) {
      response.push(populateFilter(audience.filters[i], i, true))
    } else {
      response.push(populateFilter(audience.filters[i], i))
    }
  }

  return response
}

const populateFilter = (
  filter: { attribute: { displayName: any }; operator: any; ruleTextDisplayValue: any },
  index: number,
  hasConditional = false
) => {
  return hasConditional ? (
    <div className="row" key={index}>
      <p className="mr-1 indent-5 italic text-zinc-400">and</p>
      {processFilter(filter)}
    </div>
  ) : (
    <div className="row" key={index}>
      <SignalIcon className="h-5 w-5 text-zinc-400" />
      {processFilter(filter)}
    </div>
  )
}
const processFilter = (filter: {
  displayValue?: any
  attribute: { displayName: any }
  operator: any
  ruleTextDisplayValue: any
}) => {
  const attribute = filter?.attribute?.displayName
  const operator = filter?.operator
  const rule =
    filter?.attribute?.displayName === 'Active' ? 'true' : filter?.ruleTextDisplayValue || filter?.displayValue

  return (
    <>
      <p className="text-zinc-400">{attribute}</p>
      <p className="text-zinc-400">{operator === 'eq' ? ' : ' : ' ≠ '}</p>
      <p className="text-zinc-700">{rule}</p>
    </>
  )
}
